import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { CompaniesService } from 'src/app/services/companies.service';
import { LeadSourceService } from 'src/app/services/lead-source.service';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { LeadService } from 'src/app/services/lead.service';
import { TagesStatusService } from 'src/app/services/tages-status.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'calsoft-popup-edit',
  templateUrl: './popup-edit.component.html',
  styleUrls: ['./popup-edit.component.scss']
})
export class PopupEditComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';


  url = '';

  firstFormGroup: UntypedFormGroup;
  data: any;
  key: any;
  previousValue: any;
  inputType: any;
  element: any;
  isOptionSelected: boolean;

  constructor(
    private dialogRef: MatDialogRef<PopupEditComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    public _formBuilder: UntypedFormBuilder,
    private router: Router,
    private usersService: UsersService,
    private leadService: LeadService,
    private tagesStatusService: TagesStatusService,
    private leadStatusService: LeadStatusService,
    private companiesService: CompaniesService,
    private leadSourceService: LeadSourceService,
  ) {
    this.data = data;
    this.key = data.key;

    this.previousValue = data.previousValue;
    this.inputType = data.inputType;

    this.element = data.element;
    if (!this.previousValue && this.key === 'ownerEmail' && this.element) {
      this.previousValue = this.element['ownerEmail'] || this.element['OwnerName'] || this.element['Owner'] || this.element['email'] || '';
    }
    if (this.inputType === 'multiSelect') {
      this.inputType = 'select';
    }
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  ngOnInit() {

    this.firstFormGroup = this._formBuilder.group({
      'value': [''],
    });

    if (this.key === 'tagName' || this.key === 'Tags') {
      let currentVal = this.previousValue || this.element?.tagNames || this.element?.tagName || this.element?.Tags || '';
      if (typeof currentVal === 'string' && currentVal.includes(',')) {
        currentVal = currentVal.split(',')[0].trim();
      }
      this.firstFormGroup.get("value").setValue(currentVal);
    } else {
      this.firstFormGroup.get("value").setValue(this.previousValue);
    }

    if (this.element && this.element.companyId > 0) {
      this.isOptionSelected = true;
    }

    this.getUserDropDownList();
    this.usertypeYFilter();
    this.getAllTags();
    this.TagsYFilter();
    this.getLeadStatusList();
    this.LeadStatusYFilter();
    this.getLeadSourceDownList();
    this.LeadSourceYFilter();

  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  close() {

    this.dialogRef.close({ event: 'close' })
  }

  save() {
    let val = this.firstFormGroup.value.value;
    if (this.key === 'tagName' || this.key === 'Tags') {
      let selectedTag = (this.tagsList || []).find(t => t.statusName === val || t.statusId == val);
      let object = {
        "entityId": this.element.entityId,
        "TagId": selectedTag ? selectedTag.statusId : null,
        "tagName": selectedTag ? selectedTag.statusName : (val || ''),
        "tagNames": selectedTag ? selectedTag.statusName : (val || ''),
        "tagIds": selectedTag ? String(selectedTag.statusId) : '',
        "tagNameColour": selectedTag ? selectedTag.statusColor : '',
        "Tags": selectedTag ? selectedTag.statusId : null
      };

      this.leadService.editLead(object, this.element.entityId).subscribe((response) => {
        if (this.element && selectedTag) {
          this.element.tagName = selectedTag.statusName;
          this.element.tagNames = selectedTag.statusName;
          this.element.tagIds = String(selectedTag.statusId);
          this.element.TagId = selectedTag.statusId;
          this.element.Tags = selectedTag.statusId;
          this.element.tagNameColour = selectedTag.statusColor;
        }
        this.dialogRef.close({ event: 'add', data: selectedTag ? selectedTag.statusName : val });
      });
    } else {
      this.dialogRef.close({ event: 'add', data: val });
    }
  }

  //user

  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;
  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();
  protected _onDestroy = new Subject<void>();

  getUserDropDownList() {

    let val: any = localStorage.getItem('userType')

    if (val == null) {
      val = 0;
    } else if (val == 'salesUser') {
      val = 1;
    } else {
      val = 0;
    }

    // console.log(val);

    if (!this.router.url.includes('crmAnalytics') && val == 0) {

      this.usersService.getAllUserStatusDropDown().subscribe(
        res => {
          this.userList = res;
          this.userTypeList = res;
          this.filtereduserTypeList = this.userTypeList;
        },
        error => {
        })
    } else {
      this.usersService.getAllUserStatusDropDownSales().subscribe(
        res => {
          this.userList = res;
          this.userTypeList = res;
          this.filtereduserTypeList = this.userTypeList;
        },
        error => {
        })
    }

  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }


  onOwnerSelected(event, option, element) {
    if (event.isUserInput != false) {

      console.log("option", option);


      element['OwnerId'] = option.entityId;
      element['OwnerName'] = option.email;


    }
  }

  setTagName(event, tag, entityId) {

    if (event.isUserInput != false) {

      let object = {

        "entityId": entityId,
        "TagId": tag.statusId,
        "tagName": tag.statusName,
        "Tags": tag.statusId
      }

      this.leadService.editLead(object, entityId).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            // this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          } else {
            // this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => {
        });

    }
  }

  //Tags

  tagsList: any = [];
  tagsTypeList: any = [];
  filteredtagsTypeList: any = [];
  tagsControl: UntypedFormControl = new UntypedFormControl();
  tagsFilterControl: UntypedFormControl = new UntypedFormControl();


  getAllTags() {
    this.tagesStatusService.getAllTagsDropDown(5).subscribe(
      data => {
        this.tagsList = data;
        this.tagsTypeList = data;
        this.filteredtagsTypeList = this.tagsTypeList;
      },
      error => {
      }
    )
  }

  TagsYFilter() {
    this.tagsFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.tagsFilter();
      });
  }

  protected tagsFilter() {
    if (!this.tagsTypeList) {
      return;
    }
    // get the search keyword
    let search = this.tagsFilterControl.value;
    if (!search) {
      this.filteredtagsTypeList = this.tagsTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredtagsTypeList = this.filteredtagsTypeList.filter(tags => tags['statusName'].toLowerCase().indexOf(search) > -1)
  }

  //lead status

  leadStatusList: any;
  leadStatusTypeList: any;
  filteredleadStatusTypeList: any;

  public leadStatusFilterControl: UntypedFormControl = new UntypedFormControl();

  getLeadStatusList() {

    this.leadStatusService.getAllLeadStatusDropDown(0).subscribe(
      res => {
        this.leadStatusList = res;
        this.leadStatusTypeList = res;
        this.filteredleadStatusTypeList = this.leadStatusTypeList;
      },
      error => {
      }
    )
  }

  LeadStatusYFilter() {
    this.leadStatusFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.LeadStatusFilter();
      });
  }


  protected LeadStatusFilter() {
    if (!this.leadStatusTypeList) {
      return;
    }
    // get the search keyword
    let search = this.leadStatusFilterControl.value;
    if (!search) {
      this.filteredleadStatusTypeList = this.leadStatusTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the warehouse
    this.filteredleadStatusTypeList = this.leadStatusTypeList.filter(status => status['statusName']
      .toLowerCase().indexOf(search) > -1)
  }

  //leadSource

  filteredLeadSourceTypeList: any;

  LeadSourceTypeList: any;
  LeadSourceList: any;

  getLeadSourceDownList() {

    this.leadSourceService.getAllLeadSourceDropDown().subscribe(
      res => {
        this.LeadSourceList = res;
        this.LeadSourceTypeList = res;
        this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
      },
      error => {
      })
  }


  LeadSourceYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeLeadSourceYFilter();
      });
  }


  protected typeLeadSourceYFilter() {
    if (!this.LeadSourceTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filteredLeadSourceTypeList = this.LeadSourceTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList.filter(source => source['sourceName'].toLowerCase().indexOf(search) > -1)
  }

  getAllSourcedropdowntype() {
    this.filteredLeadSourceTypeList = this.LeadSourceTypeList;
  }

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  companyList: any = [];

  getCompanyData(value) {

    if (value != '') {

      let sortParam = 'updatedDate' + "," + Constant.Dsc;

      let search = "name:" + '*' + value.trim() + '*'
        + "' OR phoneNumber:" + '*' + value.trim() + '*'
        + "' OR ownerEmail:" + '*' + value.trim() + '*' + "' "


      this.companiesService.getCompanyBySearch(search, this.page, this.size, sortParam).subscribe(
        res => {

          this.companyList = res['content'];

        },
        error => {

        })


    }


  }

  onCompanySelected(event, option, element) {
    if (event.isUserInput && option?.entityId) {

      this.element['CompanyId'] = option.entityId;
      this.element['Company'] = option.name;


    } else {
      this.element['CompanyId'] = null;
      this.element['Company'] = '';
    }
  }


  clearInputCompany() {
    this.isOptionSelected = false;

    this.firstFormGroup.get('value')?.reset();


    this.element['CompanyId'] = null;
    this.element['Company'] = '';
    this.element['companyId'] = null;

  }





  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }
}
